import { useOutletContext } from 'react-router-dom'

import { GroupsDataTable } from 'modules/expenses/components/groups/DataTable'
import { TabRouteContextParams } from 'modules/expenses/lib/RouteContextParams'

const GroupsListTab = () => {
  const { employeeIds } = useOutletContext<TabRouteContextParams>()

  return <GroupsDataTable employeeIds={employeeIds} />
}

export default GroupsListTab
